import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/styles";
import {  Divider } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    "& > h2": {
      fontWeight: "bold",
      color:'#273c75'
    },
  },
  buttons: {
    color: theme.palette.getContrastText("#EC4E4F"),
    backgroundColor: "#192a56",
    "&:hover": {
      backgroundColor: "#40739e",
    },
  },
}));

const AlertInfo = (props) => {
  const classes = useStyles();
  const { open, onClose, title, children, onAccept, ...rest } = props;
  return (
    <div>
      <Dialog
        {...rest}
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle className={classes.dialogTitle} id="alert-dialog-title">
          {title}
          <Divider style={{marginTop:5,backgroundColor:'#273c75'}} variant="fullWidth" />

        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {children}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            className={classes.buttons}
            onClick={onAccept}
            color="primary"
            autoFocus
          >
            {props.onAcceptText || "بستن"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AlertInfo;
